/* eslint-disable jsx-a11y/img-redundant-alt */
import {memo} from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import IconButton from '@material-ui/core/IconButton';
import Close from '@material-ui/icons/Close';
import useAppDispatch from 'packages/hooks/use-app-dispatch';
import {deleteSponsor} from 'redux/features/app-slice';

const useStyles = makeStyles(() => ({
  sponsor: {
    maxWidth: '100%',
    height: '100%',
    position: 'relative',
    borderRadius: 8,
  },
  topRight: {
    position: 'absolute',
    top: 0,
    right: 0,
    marginRight: 5,
    marginTop: 5,
    background: 'white',
    zIndex: 300,
  },
  img: {
    display: 'block',
    // maxWidth: 230,
    // maxHeight: 130,
    width: 200,
    height: '100%',
  },
}));

type Props = {
  url: string;
};
const Sponsor = memo(({url}: Props) => {
  const classes = useStyles();
  const dispatch = useAppDispatch();

  const handleDeleteSponsor = () => {
    dispatch(deleteSponsor(url));
  };

  return (
    <>
      <div className={classes.sponsor}>
        <IconButton
          className={classes.topRight}
          color="secondary"
          onClick={handleDeleteSponsor}
          size="small"
          component="span"
        >
          <Close />
        </IconButton>
        <img
          src={url}
          className={classes.img}
          width="100%"
          height="100%"
          alt="Sponsor image"
        />
      </div>
    </>
  );
});

Sponsor.displayName = 'Sponsor';

export default Sponsor;
